<template>
  <div class="device-block-page">
    <div class="container">
      <div class="chart-block block-odd" style="width:500px;">
        <!-- <img src="/static/images/device/nhzb.png" class="titl"> -->
        <div class="item">
          <div class="chart-box nhzb">
            <v-chart :options="options_nhzb" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts/lib/echarts'
export default{
  data() {
    return {
      nhzbList: [],
      options_nhzb: {},
    }
  },
  mounted() {
    //定义全局方法
    window.gbfc_resetData = this.resetData;
    //初始化
    this.$initPage(this);
  },
  methods: {
    resetData() {
      //能耗占比
      this.getNhzbList();
    },
    getNhzbList(){
      let self = this;
      this.nhzbList = [
        {
          TaskType: '提升机',
          Count: 400
        },
        {
          TaskType: '堆垛机',
          Count: 50
        },
        {
          TaskType: '输送机',
          Count: 450
        },
        {
          TaskType: '夹抱机',
          Count: 100
        },
        {
          TaskType: '拆垛机',
          Count: 50
        },
        {
          TaskType: '拆码盘机',
          Count: 60
        },
        {
          TaskType: '顶升移载',
          Count: 20
        },
      ];
      this.setOptionsNhzb();
    },
    setOptionsNhzb() {
      let colors = this.$charts.colors.style_13;
      let chartsConf = this.$charts[window.CurrentTheme];
      let legendData = [];
      let sdata = [];
      this.nhzbList.forEach( function(d, di) {
        legendData.push(d.TaskType);
        let tmp = {
          value: d.Count,
          name: d.TaskType,
          label: {
            normal: {
                rich: {
                  hr: {
                    borderColor: colors[di]
                  },
                  per: {
                    color: colors[di]
                  }
                }
            }
          },
          itemStyle:{
            normal:{
              color: colors[di]
            }
          }
        };
        sdata.push(tmp);
      });

      this.options_nhzb = {
        legend: {
            x : 'center',
            y : 'bottom',
            textStyle: {
              color: chartsConf.legend.color,
              fontSize: 24
            },
            data: legendData
        },
        series: [
          {
            type:'pie',
            radius: ['24%', '52%'],
            center : ['50%', '45%'],

            startAngle:160,
            //avoidLabelOverlap: true,
            labelLine: {
              //length: 30,
              length2: 40
            },
            label: {
              normal: {
                  formatter: '{per|{d}%} \n{hr|}\n {b|{b}}',
                  backgroundColor: chartsConf.series.backgroundColor,
                  // padding: [0, 0, 0, 0],
                  borderColor: chartsConf.series.borderColor,
                  borderWidth: 1,
                  rich: {
                    /*hr: {
                      //borderColor: '#fff',
                      width: '100%',
                      borderWidth: 0.5,
                      height: 0,
                    },*/
                    b: {
                      fontSize: 20,
                      color: chartsConf.series.color,
                      //padding: [0, 0, 0, 0]
                    },
                    per: {
                      align: 'center',
                      fontSize: 20,
                      //padding: [0, 0, 0, 0]
                    }
                  }
              }
            },
            data: sdata
          }
        ]
      };
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/xiayan/device/DeviceMaintainEnergy.vue